export default "__VITE_ASSET__BmTFRnf5__"